import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

interface WorkspaceCardSkeletonProps {
  delay?: number;
}

export const WorkspaceCardSkeleton = ({ delay = 0 }: WorkspaceCardSkeletonProps) => {
  return (
    <Card 
      className="p-6 animate-pulse opacity-0 animate-fade-in"
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'forwards'
      }}
    >
      <Skeleton className="h-6 w-2/3 mb-2" />
      <Skeleton className="h-4 w-1/2" />
    </Card>
  );
};

export const WorkspaceListSkeleton = () => {
  const staggerDelay = 80; // milliseconds between each element
  
  return (
    <div className="space-y-10">
      <div 
        className="opacity-0 animate-fade-in"
        style={{ animationFillMode: 'forwards' }}
      >
        <Skeleton className="h-10 w-3/4 mb-4" />
        <Skeleton className="h-6 w-full max-w-lg" />
      </div>

      <div className="space-y-4">
        <WorkspaceCardSkeleton delay={staggerDelay} />
        <WorkspaceCardSkeleton delay={staggerDelay * 2} />
        <WorkspaceCardSkeleton delay={staggerDelay * 3} />
      </div>

      <Skeleton 
        className="h-12 w-full opacity-0 animate-fade-in" 
        style={{ 
          animationDelay: `${staggerDelay * 4}ms`,
          animationFillMode: 'forwards'
        }}
      />
    </div>
  );
};
